export default "__VITE_ASSET__fd902c17__"